import { Component, OnInit, ViewChild } from '@angular/core';
import System from 'framework/System';
import { LocalProfilesComponent } from '../../../shared/local-profiles/local-profiles/local-profiles.component';
import { LocalProfileService } from '../../../../services/local-profile.service';
import { Skus } from 'app/models/enums/Skus';

@Component({
  selector: 'app-components-specialist-actioncomponents-businessprofilevalidationandaugmentation',
  templateUrl: './BusinessProfileValidationAndAugmentation.component.html'
})
export class BusinessProfileValidationAndAugmentationComponent implements IActionWorkspace, IActivatable, OnInit {
  @ViewChild(LocalProfilesComponent) localProfilesComponent: LocalProfilesComponent;

  actionViewModel: KnockoutObservable<IActionWorkspace>;
  currentAction: KnockoutObservable<Boo.Objects.Action>;
  taskDetails: Boo.Objects.ActionDetail;
  customer: Boo.Objects.Customer;
  customerUrl: string;
  gbpUrl: string;
  appleMapsUrl: string;
  bingUrl: string;
  yelpUrl: string;
  facebookUrl: string;
  isLoading = false;
  localProfileRequirements: Boo.LocalProfiles.Models.LocalProfileRequirements;

  constructor(private localProfileService: LocalProfileService) { }

  canActivate?(_user: Boo.Objects.User, _partner: Boo.Objects.Partner, params: IActionWorkspaceActivationParams): boolean {
    params.controlViewModel(this);
    this.currentAction = params.currentAction;
    this.actionViewModel = ko.observable(null);
    this.taskDetails = this.currentAction().TaskDetails;
    this.customer = params.currentAction().Customer;
    this.customerUrl = params.currentAction().Customer.Url;

    return true;
  }

  ngOnInit(): void {
    const encodedCompanyName = encodeURIComponent(this.customer.Name);
    this.gbpUrl = this.customer.Country.GoogleSearchUrl + 'search?pws=0&q=' + encodedCompanyName;
    this.appleMapsUrl = 'https://duckduckgo.com/?q=' + encodedCompanyName + '&t=h_&ia=web&iaxm=maps';
    this.bingUrl = 'https://www.bing.com/search?q=' + encodedCompanyName;
    this.yelpUrl = 'https://www.yelp.com/search?find_desc=' + encodedCompanyName;
    this.facebookUrl = 'https://www.facebook.com/search/pages/?q=' + encodedCompanyName;

    this.localProfileService.getRequirements(this.customer.CustomerId)
      .subscribe({
        next: (requirements) => {
          this.localProfileRequirements = requirements;
        },
        error: (error) => {
          toastr.error('Failed to load local profile requirements', error);
        }
      });
  }

  isStepReadyToReject(): boolean {
    return false;
  }

  isStepReadyToSave(): boolean {
    return false;
  }

  isStepReadyToComplete(): boolean {
    if (this.localProfilesComponent.hasPendingChanges()) {
      toastr.error('You have pending changes. Please save them before completing this task.');
      return false;
    }

    if (!this.localProfilesComponent.isValid()) {
      return false;
    }

    return true;
  }

  isStepReadyToDelete(): boolean {
    return false;
  }
}
